<swiper-container
  #swiperEl
  init="false"
  slides-per-view="1"
  space-between="16"
  grab-cursor="true"
  observer="true"
  observe-slide-children="true"
  auto-height="true"
>
  @for (slide of slides(); track slide) {
    <swiper-slide>
      <div class="disclaimer-slide">
        <ng-container [ngTemplateOutlet]="slide.templateRef"></ng-container>
      </div>
    </swiper-slide>
  }
</swiper-container>

<div
  class="carousel-controls"
  [class.carousel-controls--single]="slides().length <= 1"
  [class.carousel-controls--detail]="detailView()"
>
  <button
    #prevEl
    type="button"
    class="carousel-arrow carousel-arrow--prev"
    aria-label="Previous"
  >
    <svg viewBox="0 0 16 16" aria-hidden="true">
      <path
        d="M10 3.5 5.5 8 10 12.5"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </button>

  <div #paginationEl class="carousel-pagination"></div>

  <button
    #nextEl
    type="button"
    class="carousel-arrow carousel-arrow--next"
    aria-label="Next"
  >
    <svg viewBox="0 0 16 16" aria-hidden="true">
      <path
        d="M6 3.5 10.5 8 6 12.5"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </button>
</div>